"use client";

// packages/eden-icons/src/generated-from-source/ChevronRight.jsx
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
var ChevronRight = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M16.223 12.538a.75.75 0 0 0 0-1.076l-5.4-5.25a.75.75 0 1 0-1.046 1.076l4.858 4.702-4.858 4.722a.75.75 0 0 0 1.046 1.076l5.4-5.25z", children: " " })
] });
var ChevronRight_default = ChevronRight;
export {
  ChevronRight_default as default
};
